var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 477.175,
    height: 477.175,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90, 238.588, 238.588)",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#09D3AC",
    className: "active-path",
    d: "m145.188004,238.574997l215.499985,-215.499996c5.300018,-5.300001 5.300018,-13.800001 0,-19.100001s-13.799988,-5.3 -19.099976,0l-225.100014,225.099997c-5.299995,5.300003 -5.299995,13.800003 0,19.100006l225.100014,224.999985c2.599976,2.600006 6.099976,4 9.5,4s6.899994,-1.299988 9.5,-4c5.299988,-5.299988 5.299988,-13.799988 0,-19.099976l-215.400009,-215.500015z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.28edabd6ed76401115f31f39cbf881d7.svg";
export { ForwardRef as ReactComponent };